<template>
  <a-tooltip
    v-if="hasContent"
    :title="String(text)"
    placement="topLeft"
    :mouse-enter-delay="0.2"
  >
    <span :class="['ellipsis-cell', { mono: mono, small: small }]">
      <slot>{{ text }}</slot>
    </span>
  </a-tooltip>
  <span v-else class="ellipsis-cell empty">-</span>
</template>

<script>
// 공용 a-table 컬럼 ellipsis + tooltip 래퍼.
// 사용: <EllipsisCell :text="record.designRequirements" />
// 옵션: mono(고정폭 글꼴), small(작은 글씨)
export default {
  name: 'EllipsisCell',
  props: {
    text: { type: [String, Number, null], default: null },
    mono: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
  },
  computed: {
    hasContent() {
      if (this.text === null || this.text === undefined) return false;
      const s = String(this.text).trim();
      return s.length > 0 && s !== '-';
    },
  },
};
</script>

<style scoped>
.ellipsis-cell {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.ellipsis-cell.mono { font-family: monospace; }
.ellipsis-cell.small { font-size: 11px; }
.ellipsis-cell.empty { color: #ccc; }
</style>
